module.exports = __webpack_public_path__ + "media/images/app/header/of-52cd0789679bfdc09570efe7e68ff238.svg";